import { createAsyncThunk } from "@reduxjs/toolkit";
import overallReportingApi from "app/api/overallReporting";

export const getReportValidation = createAsyncThunk(
    "reporting/getReportValidation",
    async (payload, { rejectWithValue }) => {
        // await sleep(2000);
        return overallReportingApi.getReportValidation({
            items: payload.items
        })
            .then((response) => response)
            .catch((error) => rejectWithValue(error));
    }
);
